module.exports = __webpack_public_path__ + "static/media/face_2_anxious.743dad60.svg";